var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showBuscadorCupos)?_c('v-card',{staticClass:"pt-4 grey lighten-4",attrs:{"img":_vm.app.bkBuscador}},[_c('v-container',{attrs:{"fluid":""}},[_c('BuscadorCupo')],1)],1):_vm._e(),_c('ContenedorRsCupos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }